var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-lang"},_vm._l((_vm.locales),function(locale){return _c('div',{key:locale,class:[
      locale == _vm.i18n.locale ? 'active' : 'inactive',
      'lang-select']},[_c('div',{class:[ locale == _vm.i18n.locale ? 'active' : 'inactive', 'lang-item'],on:{"click":function($event){return _vm.changeLocale(locale)}}},[_vm._v(_vm._s(locale)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }